export default {
  SET_METADATA(state, metadata) {
    state.metadatas = metadata
  },
  SET_METADATA_COUNT(state, count) {
    state.metadatasCount = count
  },
  REMOVE_RECORD(state, itemId) {
    const metadataIndex = state.metadatas.findIndex(u => u.id === itemId)
    state.metadatas.splice(metadataIndex, 1)
  }
}
